module.exports = __webpack_public_path__ + "static/media/ITW BUSINESS MODEL.46d5d39b.svg";